import React, { useEffect, useState } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import SmallLoader from "../../../Components/Common/smallLoader";
import { Constants } from "../../../CommonMethhods/Constants";
import Loader from "../../../Components/Common/Loader";
import { toast } from "react-toastify";
import Laste10TransTable from "../../../Components/ReportTables/Laste10TransTable";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function Last10TradeTransReportNew() {
  const storeToken = localStorage.getItem("ssoToken");
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [errorGrid, setErrorGrid] = useState(false);
  const ClientId2 = localStorage.getItem("ClientId2");

  let clientCode = "";

  const getlast10TransReport = async (fileView) => {
    if (fileView === "excel") {
      setSmallLoaderExcel(true);
    }
    if (fileView === "pdf") {
      setSmallLoaderPdf(true);
    }
    if (fileView === "mail") {
      setSmallLoaderMail(true);
    }
    if (fileView === "grid") {
      setLoader(true);
    }
    let payloadValue = {
      clientCode: clientCode || ClientId2,
      fileType: fileView,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.Last10TransactionTrade_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileView === "grid") {
          setData(res?.data);
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileView === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else {
          toast.success("Mail sent successfully");
        }
      } else {
        setData([]);
        if (fileView !== "grid") {
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");
      getlast10TransReport("grid", clientCode);
    }
  }, []);

  const handleOnClick = (e) => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");
      if (e.target.value) {
        getlast10TransReport(e.target.value, clientCode);
        setError(false);
      }
    }
  };

  return (
    <>
      <div
        className="tab-pane fade show active"
        id="tax-report"
        role="tabpanel"
        aria-labelledby="tax-report"
      >
        <div className="reports-date-filter justify-content-end">
          <div className="report-btn-wrapper">
            <button
              className="generate-button mail-btn"
              value="mail"
              onClick={handleOnClick}
            >
              {smallLoaderMail ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-email"></span>
                  E-Mail
                </>
              )}
            </button>
            <button
              value="excel"
              onClick={handleOnClick}
              className="generate-button excel-btn"
            >
              {smallLoaderExcel ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  {Constants.Excel}
                </>
              )}
            </button>
            <button
              className="generate-button pdf-btn"
              value="pdf"
              onClick={handleOnClick}
            >
              {smallLoaderPdf ? (
                <div>
                  <SmallLoader />
                </div>
              ) : (
                <>
                  <span className="icon-pdfsvg"></span>
                  {Constants.PDF}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : data && data.length > 0 ? (
        <div>
          <Laste10TransTable data={data} />
        </div>
      ) : serverError ? (
        <h4 className="report-error-message">{noDataFound(serverError)}</h4>
      ) : errorGrid ? (
        noDataFound(errorGrid)
      ) : (
        ""
      )}
    </>
  );
}
export default Last10TradeTransReportNew;
